export default __webpack_public_path__ + "static/media/fuel_grey.ce6628c6.svg";